import React from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import {
  TableCell,
  TableRow,
  TableSortLabel
} from '@material-ui/core';


const DataMappingTableHeadRow = ({sort, handleRequestSort, headTableCells}) => {
  const {fieldName, sortDirection} = sort;

  return (
    <TableRow>
      {headTableCells.map((cell, index) => {
        if (!cell.display) {
          return null;
        }

        return (
          <TableCell
            key={index}
            className={`min-w-80 ${cell?.align ? cell.align : ''}`}
            width={cell?.width ? cell.width : 'auto'}
          >
            {cell.sortField ? (
              <TableSortLabel
                active={fieldName === cell.sortField}
                IconComponent={sortDirection === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon}
                onClick={(event) => handleRequestSort(event, cell.sortField)}
              >
                <div dangerouslySetInnerHTML={{__html: cell.title}} />
              </TableSortLabel>
            ) : (
              cell.label
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default DataMappingTableHeadRow;
